export function fmtPrice(n: number | null | undefined, currency = ''): string {
  if (n == null || Number.isNaN(n)) return '—'
  const abs = Math.abs(n)
  const digits = abs >= 1000 ? 2 : abs >= 1 ? 2 : 4
  const s = n.toLocaleString('en-US', { minimumFractionDigits: digits, maximumFractionDigits: digits })
  return currency ? `${currency}${s}` : s
}

/** Money amounts (P&L, balances): always 2 decimals — unlike fmtPrice, which widens to 4
 *  for sub-$1 *prices* (penny stocks) and would render a flat P&L as "$0.0000". */
export function fmtMoney(n: number | null | undefined, currency = '$'): string {
  if (n == null || Number.isNaN(n)) return '—'
  const s = n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
  return `${currency}${s}`
}

export function fmtPct(n: number | null | undefined): string {
  if (n == null || Number.isNaN(n)) return '—'
  const sign = n > 0 ? '+' : ''
  return `${sign}${n.toFixed(2)}%`
}

export function fmtChange(n: number | null | undefined): string {
  if (n == null || Number.isNaN(n)) return '—'
  const sign = n > 0 ? '+' : ''
  return `${sign}${n.toFixed(2)}`
}

export function fmtCompact(n: number | null | undefined): string {
  if (n == null || Number.isNaN(n)) return '—'
  const abs = Math.abs(n)
  if (abs >= 1e12) return `${(n / 1e12).toFixed(2)}T`
  if (abs >= 1e9) return `${(n / 1e9).toFixed(2)}B`
  if (abs >= 1e6) return `${(n / 1e6).toFixed(2)}M`
  if (abs >= 1e3) return `${(n / 1e3).toFixed(1)}K`
  return String(n)
}

/** Direction → semantic token class (the only color in the UI). */
export function dirClass(n: number | null | undefined): string {
  if (n == null || Number.isNaN(n) || n === 0) return 'text-flat'
  return n > 0 ? 'text-up' : 'text-down'
}

export function dirTone(n: number | null | undefined): 'up' | 'down' | 'neutral' {
  if (n == null || Number.isNaN(n) || n === 0) return 'neutral'
  return n > 0 ? 'up' : 'down'
}
